// extracted by mini-css-extract-plugin
export default {"header":"login_header__WrczL","container":"login_container__P0FSm","formButton":"login_formButton__luGI-","authButtonsContainer":"login_authButtonsContainer__0zD6s"};